module.exports = {
  notIssued: 'Not issued',
  getBack: 'Have to retrieve',
  receive: 'Have received',
  toClaim: 'claimed',
  issuance: 'Has been issued',
  changeSingle: 'Change in the single',
  lineCreditDialog: {
    title: 'Prompt information',
    businessNumber: 'This business number：',
    mblNo: 'MBL NO：',
    hblNo: 'HBL NO：',
    partners: 'Partners：',
    lines: 'Credit limit: exceeded, {0} yuan',
    paymentDays: 'Credit payment days: {0}',
    unableSave: 'Customer Order cannot be used. Please pay in time.',
    cantUse: 'The customer outgoing order field checkboxes cannot be saved currently.',
    triggerRemind: 'The system has been triggered. Please pay in time.',
    through: 'Order release rules approved',
    continueOrders: 'Are you sure to continue to release the document?',
    confirm: 'confirm',
    cancel: 'Shut down'
  }
}
